// Risks Redux States
import { GET_RISKS_MODULES, GET_RISKS_MODULES_SUCCESS, GET_RISKS_MODULES_FAIL, SET_SELECTED_RISK } from "./actionTypes";

const INIT_STATE = {
  risks: [],
  loadingState: "NOT_LOADED",
  // NOT_LOADED -> Loading -> LOADED
  //                       \-> ERROR
  selectedRisk: "",
  error: {
    message: "",
  },
};

const RisksReducer = (state = INIT_STATE, action) => {
  let newState = state;
  switch (action.type) {
    case GET_RISKS_MODULES:
      newState = { ...state, loadingState: "LOADING" };
      break;

    case GET_RISKS_MODULES_SUCCESS:
      newState = { ...state, risks: action.payload, loadingState: "LOADED" };
      break;

    case GET_RISKS_MODULES_FAIL:
      newState = {
        ...state,
        error: {
          message: action.payload,
        },
        loadingState: "ERROR",
      };
      break;

    case SET_SELECTED_RISK:
      newState = {
        ...state,
        selectedRisk: action.address,
      };
      break;

    default:
      break;
  }
  return newState;
};

export default RisksReducer;
